import type { User, SingleRecordResponse } from '~/types'

export const useUserApi = () => {
  const search = async () => {
    return useApiGet<SingleRecordResponse<User.Model>>('/user/')
  }

  return { search }
}
